import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const CustomerRFVForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Campeões", value: "CAMPEOES" },
    { label: "Promissores", value: "PROMISSORES" },
    { label: "Requer atenção", value: "REQUER_ATENCAO" },
    { label: "Em risco", value: "EM_RISCO" },
    { label: "Desligando", value: "DESLIGANDO" },
    { label: "Hibernando", value: "HIBERNANDO" },
    { label: "Abandonados", value: "ABANDONADOS" },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerRFV}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
